import React from 'react';
import { toast } from 'react-toastify';
import { Button } from '../../commons';
import { Input, Textarea } from '../../inputs';

export default function SupportForm() {
  return (
    <form method="POST" action="https://formsubmit.co/sandrea_johnson@bat.com">
      <div className="grid grid-cols-2 grid-rows-2 gap-4">
        <Input
          type="text"
          name="name"
          label="Name"
          placeholder="Name"
          required
        />
        <Input
          type="email"
          name="email"
          label="Email"
          placeholder="Email"
          required
        />
        <Input
          type="text"
          name="subject"
          label="Subject"
          placeholder="Subject"
          required
        />
        <Textarea name="message" label="Message" placeholder="Message" />
      </div>
      <input type="hidden" name="_cc" value="jose+carrerasltd@avilatek.com" />
      <Button type="submit" color="blue" className="text-center w-full mt-5">
        Send message
      </Button>
    </form>
  );
}
